import React, { useState, useEffect, useCallback } from 'react';
import './index.less';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header'
import { getConfigParams, authCallBack } from '@/server/index';
import { useSearchParams } from "react-router-dom";
import { Message, Image } from "@arco-design/web-react";
import { Helmet } from "react-helmet";
const { location } = window;
const url = location.href
// const url = 'https://h5.zxaigc.com/web/douyin?code=31d3f646-4c13-4f29-9f75-ad0f1f6b86d1'
const timestamp = String(parseInt(String(Date.now() / 1000))); // 生成签名用的时间戳

// 生成随机字符串的函数
const generateNonceStr = (length = 16) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const nonce_str = generateNonceStr(); // 生成签名用的随机字符串
const jsb = ''; // 自定义测试用JSB方法名
const params = {}; // 自定义测试用JSB方法参数
const PageHome = () => {
  const [search] = useSearchParams()
  const navigate = useNavigate();
  const [code] = useState(search.get('code'));
  const job_code = search.get('job_code')
  const [sdk, setSdk] = useState(null);
  const [ready, setReady] = useState(false);
  const [configStatus, setConfigStatus] = useState('');
  const [resultMsg, setResultMsg] = useState('');
  const [client_key, setClientKey] = useState('');
  const [log, setLog] = useState('');
  const [error, setError] = useState('');
  const [ticket, setTicket] = useState(null);
  const [tickLog, setTickLog] = useState('');
  const [third_uid, setThird_uid] = useState(null);
  const [isSouyin, setIsDouyin] = useState(true)
  const [isWeixin, setIsWeixin] = useState(false)
  const toLogin = () => {
    onClickAuth()
  }
  useEffect(() => {
    if (ticket) {
      authCallBack({ ticket: ticket, state: '' }).then(res => {
        setThird_uid(res.data.third_uid);
        navigate(`/web/douyin/share?third_uid=${res.data.third_uid}&nickname=${res.data.nickname}` + (code ? `&code=${code}` : '') + (job_code ? `&job_code=${job_code}` : ''))
      })
    }
  }, [ticket]);
  // 打开原生授权页面JSB能力示例
  const onClickAuth = () => {
    if (ready) {
      sdk.showOpenAuth({
        params: {
          client_key,
          state: '',
          scopes: {
            "user_info": 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
            "video.data": 0,
            "renew_refresh_token": 0,
            "item.comment": 0,
            "h5.share": 0
          },
          response_type: 'code'
        },
        success: (res) => {
          console.log(res, '获取到的授权信息')
          const { ticket } = res;
          setTicket(ticket);
        },
        error: res => {
          console.log(res, 'res')
        }
      });
    } else {
      Message.error('JSB 未就绪，请稍后重试');
    }
  };

  // 可在URL参数中自定义JSB方法名和参数以测试
  const onClickJSB = () => {
    if (ready) {
      sdk[jsb]({
        params,
        success: res => setResultMsg(`JSB ${jsb} Success: ${JSON.stringify(res)}`),
        error: res => setResultMsg(`JSB ${jsb} Error: ${JSON.stringify(res)}`)
      });
    }
  };


  // 使用JSB能力前，必须先通过Config验证签名
  const config = useCallback(async () => {
    const { client_key, signature } = await getConfigParams({ timestamp, nonce_str, url });
    console.log(client_key, signature, timestamp, nonce_str, url, '签名参数')
    setLog(`client_key: ${client_key}, signature: ${signature} timestamp: ${timestamp}, nonce_str: ${nonce_str}, url:${url}`,);
    sdk.config({
      params: {
        client_key,
        signature,
        timestamp,
        nonce_str,
        url: url
      }
    })
    setClientKey(client_key);
  }, [sdk]);

  const checkEnvironment = () => {
    const isDouyin = /aweme/i.test(navigator.userAgent);
    const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
    console.log(isDouyin, 'isDouyin', isWeixin, 'isWeixin')
    setIsDouyin(isDouyin);
    setIsWeixin(isWeixin);

    if (isWeixin) {
      Message.error('请在浏览器中打开链接！');
      return;
    }

    if (isDouyin === false) {
      const tryOpenDouyin = () => {
        const currentUrl = encodeURIComponent(window.location.href);
        const appScheme = `snssdk1128://webview/?url=${currentUrl}&type=webview&from=web`;
        window.location.href = appScheme;
      }

      // 第一次尝试
      setTimeout(tryOpenDouyin, 2000);

      // 如果5秒后还在当前页面，再次尝试
      setTimeout(() => {
        if (document.hidden === false) {
          tryOpenDouyin();
        }
      }, 5000);
    }
  }

  useEffect(() => {
    setSdk(window.douyin_open);
    if (sdk) {
      setConfigStatus('SDK Loaded');
      console.log('SDK Loaded')
      config();
      sdk.ready(() => {
        setReady(true);
        console.log('SDK Ready')
      });
      sdk.error(res => {
        console.log('SDK Config Error')
      });
    }
    checkEnvironment();
  }, [sdk, config]);
  return (
    <div className="homePage">
      <Helmet>
        <title>授权登录</title>
      </Helmet>
      <div className="nav-logo" />
      <div className="nav-title" />
      <div className="nav-desc">
        <div className="nav-desc-box">
          <div className="label">哈喽～快来实现你的无限创意吧！</div>
        </div>
      </div>
      <div className="footer-btn">
        <div onClick={() => {
          toLogin()
        }} className="submit-btn1">一键授权登录</div>
        <div className="shouquan">如您点击授权,您将同意并授权</div>
        <div className="yonghu"><span onClick={() => {
          window.open("/policy.html", "policy");
        }}>平台隐私政策</span>, <span onClick={() => {
          window.open("/agreement.html", "agreement");
        }}>平台用户服务协议</span></div>
      </div>
      <div style={{ display: !isSouyin ? 'block' : 'none' }} className="dy-modal" id="dyModal">
        <div className="modal-content">
          <h3>请在抖音App内继续操作</h3>
          {
            isWeixin && <p>检测到当前为微信环境，请在浏览器中打开链接</p>
          }
          {
            !isWeixin && <p>检测到当前未使用抖音打开，请使用抖音打开链接</p>
          }
        </div>
      </div>
    </div>
  );
};

export default PageHome;
